
import { request } from "./request"

export default {
  /**
   * OperationView 报表数据
   */
  getOperationView(search) {
    return request({
      url: "/order/GetOperationView",
      method: "post",
      data: search
    })

  },
    /**
  * GetAAContractSummaryList 报表数据
  */
    GetAAContractSummaryList(search) {
      return request({
        url: "/order/GetAAContractSummaryList",
        method: "post",
        data: search
      })
  
    },
      /**
  * GetAMContractSummaryList 报表数据
  */
  GetAMContractSummaryList(search) {
    return request({
      url: "/order/GetAMContractSummaryList",
      method: "post",
      data: search
    })

  },
    /**
  * GetGPContractSummaryList 报表数据
  */
    GetGPContractSummaryList(search) {
      return request({
        url: "/order/GetGPContractSummaryList",
        method: "post",
        data: search
      })
  
    },
}


